import { PostSvg } from "@/assets/icons";
import styles from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { useCommonStore, useUserStore } from "@/stores";
import clsx from "clsx";
import FTAnalytic from "@/analyze/FTAnalytic";

type PostButtonProps = {
  className?: string;
}

const PostButton = (props: PostButtonProps) => {
  const {
    className, 
  } = props;

  const { t } = useTranslation();

  const task = useCommonStore(state => state.task);
  const userInfo = useUserStore(state => state.userInfo);

  const handleClick = () => {
    window.open(`${process.env.REACT_APP_COMMUNITY_URL}/p/${userInfo.id}/?facemimic=${task?.taskId}`);

    // 埋点
    FTAnalytic.addAnalytic({
      type: 'ev',
      action: 'fotor_web$click$community_work_post_enter',
      label: {
        creation_type: "face_mimic",
      },
    });
  }

  return (
    <button
      className={clsx(
        styles["root"],
        className,
      )}
      onClick={handleClick}
    >
      <PostSvg></PostSvg>
      <span>{t("post_button")}</span>
    </button>
  )
}

export default PostButton;